<template>
  <div>

    <card card-body-classes="" no-footer-line>

      <h4 slot="header" class="title title-up">{{ (scope == 'edit') ? 'Update' : (scope == 'view') ? 'View': 'Create New' }} News</h4>
      <form>
        <div class="row">

          <div class="col-6">
              <!-- <label>Cover Image</label> -->
              <fg-input
                  required
                  type="text"
                  name="image"
                  label="Cover Image"
                  :rows="5"
                  v-validate="modelValidations.image"
                  :error="getError('image')"
                  v-model="model.image"
                  :disabled="(this.scope == 'view')">
              <el-upload
                  class="avatar-uploader"
                  name="image"
                  accept="image/jpeg,image/png"
                  :data="{path: 'news/'}"
                  :action="uploadURL"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :disabled="(this.scope == 'view')">
                  <!-- <img v-if="model.image" :src="model.image" class="avatar"> -->
                  <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              </fg-input>
          </div>

          <div class="col-6">
            <div class="row">
              <div class="col-3">
                  <fg-input
                      type="text"
                      required
                      name="featured_news"
                      label="Featured News ?"
                      v-validate="modelValidations.featured_news"
                      :error="getError('featured_news')"
                      v-model="model.featured_news"
                      :disabled="(this.scope == 'view')">
                      <n-switch v-model="model.featured_news" on-text="Yes" off-text="No" :disabled="(this.scope == 'view')"></n-switch>
                  </fg-input>
              </div>
              <div class="col-3">
                  <fg-input
                      type="text"
                      required
                      name="draft"
                      label="Draft News ?"
                      v-validate="modelValidations.draft"
                      :error="getError('draft')"
                      v-model="model.draft"
                      :disabled="(this.scope == 'view')">
                      <n-switch v-model="model.draft" on-text="Yes" off-text="No" :disabled="(this.scope == 'view')"></n-switch>
                  </fg-input>
              </div>
              <div class="col-6">
                  <fg-input
                      type="text"
                      required
                      name="author"
                      label="Author"
                      v-validate="modelValidations.author"
                      :error="getError('author')"
                      v-model="model.author"
                      :disabled="(this.scope == 'view')">
                      <el-select class="select-primary" 
                        placeholder="Select Author" 
                        v-model="model.author" 
                        value-key="register_no" 
                        clearable filterable 
                        :remote-method="remoteMethod" 
                        remote 
                        reserve-keyword 
                        :disabled="(this.scope == 'view')">
                          <el-option-group
                            v-for="group in groups"
                            :key="group"
                            :label="group">
                                <el-option
                                    v-for="(option, index) in users[group]"
                                    class="select-primary"
                                    :value="option" 
                                    :label="`${option.register_no} - ${option.name}`" 
                                    :key="index">
                                </el-option>
                            </el-option-group>
                          <!-- <el-option v-for="(option, index) in authors" class="select-primary" :value="option" :label="`${option.register_no} - ${option.name}`" :key="index">
                          </el-option> -->
                      </el-select>
                  </fg-input>
              </div>
              <div class="col-6">
                    <fg-input
                    type="date"
                    name="date"
                    label="Date"
                    v-validate="modelValidations.date"
                    :error="getError('date')"
                    v-model="model.date"
                    :disabled="(this.scope == 'view')">
                    <el-date-picker 
                        v-model="model.date" 
                        type="date" 
                        placeholder="date"
                        :disabled="(this.scope == 'view')">
                    </el-date-picker>
                    </fg-input>
                </div>
                <div class="col-6">
                  <fg-input
                      type="text"
                      name="input"
                      label="Tags"
                      v-validate="modelValidations.input"
                      :error="getError('input')"
                      v-model="model.input"
                      :disabled="(this.scope == 'view')">
                      <el-tag :key="index" v-for="(val, index) in model.tags" size="small" type="primary" :closable="true" :close-transition="false" @close="handleClose(val)">{{ val }}</el-tag>
                      <input type="text" placeholder="Add new tag" class="form-control input-new-tag" v-model="model.input" ref="saveTagInput" size="mini" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                  </fg-input>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4">
              <fg-input
                  type="text"
                  required
                  name="title"
                  label="News Title"
                  v-validate="modelValidations.title"
                  :error="getError('title')"
                  v-model="model.title"
                  :disabled="(this.scope == 'view')">
              </fg-input>
          </div>

          <div class="col-12 mt-4">
              <fg-input
                  required
                  type="textarea"
                  name="small_description"
                  label="Small Description"
                  :rows="5"
                  v-validate="modelValidations.small_description"
                  :error="getError('small_description')"
                  v-model="model.small_description"
                  :disabled="(this.scope == 'view')">
                  <!-- <ckeditor :editor="editor" v-model="model.small_description" :config="editorConfig"></ckeditor> -->
              </fg-input>
          </div>

          <div class="col-12 mt-4">
              <fg-input
                  required
                  type="text"
                  name="long_description"
                  label="Long Description"
                  v-validate="modelValidations.long_description"
                  :error="getError('long_description')"
                  v-model="model.long_description">
                  <ckeditor :editor="editor" v-model="model.long_description" :config="editorConfig" :disabled="(this.scope == 'view')"></ckeditor>
              </fg-input>
          </div>

          <div class="col-12 text-center" v-if="this.scope != 'view'">
            <n-button @click.native.prevent="validate()" type="primary">Save News</n-button>
          </div>
          
        </div>
      </form>

    </card>

  </div>
</template>
<script>
import { Card, Switch } from 'src/components';
import { Select, Option, OptionGroup, Tag, Upload, DatePicker } from "element-ui";

import { mapGetters } from 'vuex';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';

export default {
  components: {
    Card,
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Upload.name]: Upload,
    [DatePicker.name]: DatePicker
  },
  computed: {
    ...mapGetters({
        users: 'getUsers',
        authTokens: 'getAuthTokens',
        new: 'getNew',
    }),
    headers(){
        this.authTokens['content-type'] = 'multipart/form-data'
        let {token, refreshtoken} = this.authTokens
        return {token, refreshtoken};
    },
    uploadURL(){
        return `${process.env.VUE_APP_BASE_URL}/glimpses/upload`
    },
    scope(){
      return this.$route.path.includes('edit') ? 'edit' : this.$route.path.includes('view') ? 'view' : 'add'
    },
    authors(){
        let students = Object.assign([],this.users.students)
        let teachers = Object.assign([],this.users.teachers)
        return students.concat(teachers)
    }
  },
  data() {
    return {
        loading: false,
        groups: ['students', 'teachers'],
        model: {
            title: '',
            date: null,
            featured_news: false,
            draft: true,
            author: '',
            tags: [],
            image: null,
            small_description: 'Content of the editor small.',
            long_description: '<p>Content of the editor long.</p>',
            input: '',
            
        },
        editor: ClassicEditor,
        editorConfig: {
            // The configuration of the editor.
        },
        modelValidations: {
            title: {
                required: true,
            },
            author: {
                required: true,
            },
            small_description: {
                required: true,
            },
            long_description: {
                required: true,
            },
            image: {
                required: true,
            },
        },
        filterMethod(query, item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
    };
  },
  methods: {
    getError(fieldName) {
        return this.errors.first(fieldName);
    },
    validate() {
        this.$validator.validateAll().then(isValid => {
            if(isValid){
                switch(this.scope){
                    case 'add'  : this.$store.dispatch('createNews', Object.assign({}, this.model)); break;
                    case 'edit' : this.$store.dispatch('updateNews', Object.assign({}, this.model)); break;
                }
            }
        });
    },
    handleClose (val) {
        this.model.tags.splice(this.model.tags.indexOf(val), 1)
    },
    handleInputConfirm () {
        let inputValue = this.model.input
        if (inputValue) {
            this.model.tags.push(inputValue)
        }
        this.model.input = ''
    },
    handlePreview(file) {
        this.model.image = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess(res, file) {
        this.model.image = res.data.image;
    },
    beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        console.log(isLt2M);
        
        if (!isLt2M) {
            this.$notify({
                message: `Cover picture size can not exceed 2MB!`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            })
        }
        return isLt2M;
    },
    remoteMethod(query) {
        this.$store.dispatch('searchUsers', query)
    }
  },
  mounted() {
    if(this.scope == 'edit' || this.scope == 'view' ){
      this.$store.dispatch('getNew', this.$route.params.id)
    }
  },
  watch: {
    new(value){
      this.model = Object.assign({}, value)
      this.$store.dispatch('searchUsers', value.author.name)
    }
  }
};
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-select-dropdown__wrap{
      height: 400px!important;
      max-height: 400px!important;
  }
</style>
